module.exports = __webpack_public_path__ + "img/Pot2.527b9edc.svg";